import React, { useState } from "react";
import { DatePicker, Space, Select, Input } from "antd";
import { SERVICE_PROVIDER_DETAILS } from "../../constants/serviceProviders";

const PickupRequestFilters = ({ filters, onFiltersChange }) => {
  const [searchField, setSearchField] = useState("trackingNo");

  const searchBy = (
    <Select
      defaultValue="trackingNo"
      className="select-before"
      onChange={(value) => setSearchField(value)}
    >
      <Select.Option value="trackingNo">Tracking No</Select.Option>
      <Select.Option value="userEmail">User Email</Select.Option>
      <Select.Option value="pickupEmail">Pickup Email</Select.Option>
    </Select>
  );

  return (
    <Space size="large" wrap>
      <div>
        Pickup Created At :{` `}
        <DatePicker.RangePicker
          allowClear={false}
          allowEmpty={false}
          value={[filters.startDate, filters.endDate]}
          onChange={(dates) => {
            dates
              ? onFiltersChange({
                  ...filters,
                  startDate: dates[0],
                  endDate: dates[1],
                })
              : onFiltersChange({
                  ...filters,
                  startDate: undefined,
                  endDate: undefined,
                });
          }}
        />
      </div>

      <div>
        <Input.Search
          addonBefore={searchBy}
          placeholder="Search"
          allowClear={true}
          onSearch={(term) =>
            onFiltersChange({ ...filters, search: term, searchField })
          }
        />
      </div>

      <div>
        Courier :{` `}
        <Select
          placeholder="ALL"
          style={{ width: 200 }}
          allowClear
          onChange={(value) =>
            onFiltersChange({ ...filters, serviceProvider: value })
          }
        >
          {SERVICE_PROVIDER_DETAILS.filter((courier) => courier.hasPickup).map(
            (courier) => (
              <Select.Option value={courier.key}>{courier.name}</Select.Option>
            )
          )}
        </Select>
      </div>
    </Space>
  );
};

export default PickupRequestFilters;
